export const KNOWN_ERRORS_CODES = {
  EXPECTATION_FAILED: 417
};

export const FILE_ERRORS = {
  UNKNOWN: 'UNKNOWN',
  UNABLE_TO_UPLOAD_FILES: 'UNABLE_TO_UPLOAD_FILES'
};
